import React, {
  FC, useMemo, useState, FormEvent, useEffect
} from 'react'
import queryString from 'query-string'
import firebase from 'firebase/app'
import { useHistory, useLocation } from 'react-router-dom'
import { useForm } from '../utils'
import { resetPasswordValidation } from '../Auth/Validation/resetPasswordValidation'
import {
  Form, Grid, LabelWrapper, LineInput, Button, Heading
} from '../System'
import { validatePassword, validateConfirmPassword } from '../User/userUtil'
import { Controller } from '../System/Form'
import { useNotifications } from '../Notifications'
import ROUTES from '../utils/routes'
import { Marketing } from '../Auth/Marketing'
import { StyledSignInView } from '../SignInView'
import { WidthController } from '../Grid'
import { FormMessageType } from '../../types'

const ResetPasswordView: FC = () => {
  const location = useLocation()
  const validation = useMemo(() => resetPasswordValidation, [])
  const history = useHistory()
  const urlQuery = queryString.parse(location.search)
  const { oobCode = '' } = urlQuery
  const { values, control, getError } = useForm({ shouldUnregister: false, mode: 'onBlur' })
  const { addNotification } = useNotifications()
  const [formMessage, setFormMessage] = useState<FormMessageType>()
  const [loading, setLoading] = useState(false)

  const resetUserPassword = async (e: FormEvent) => {
    e.preventDefault()
    setLoading(true)

    try {
      const isNotSame = validateConfirmPassword([values.password, values.passwordConf])
      const passwordIsWrong = validatePassword(values.password)

      if (isNotSame) {
        throw Error(isNotSame)
      }

      if (passwordIsWrong) {
        throw Error(passwordIsWrong)
      }

      await firebase.auth().confirmPasswordReset(`${oobCode}`, values.password)

      addNotification({ message: 'Your password has been reset', type: 'success' })
      history.push(ROUTES.user.login)
    }
    catch (err) {
      setFormMessage({
        message: err.message,
        type: 'error'
      })
    }
    finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (oobCode === '') {
      history.push(ROUTES.errors.fiveHundred, { message: 'Password reset code was not found' })
    }
  }, [])

  return (
    <StyledSignInView>
      <Marketing />
      <div id="form" className="auth-information">
        <WidthController noHeight noPadding maxWidth={420}>
          <Heading>Reset Your Password</Heading>
          <Form message={formMessage} onSubmit={(e) => resetUserPassword(e)}>
            <Grid inLayout gap={12}>
              <LabelWrapper label="Password" errorMessage={getError('password')}>
                <Controller
                  name="password"
                  control={control}
                  rules={validation.password}
                  component={<LineInput placeholder="Password" type="password" />}
                />
              </LabelWrapper>

              <LabelWrapper errorMessage={getError('passwordConf')}>
                <Controller
                  name="passwordConf"
                  control={control}
                  rules={{
                    ...validation.passwordConf,
                    validate: { value: (value) => value === values.password || 'Passwords do not match' }
                  }}
                  component={<LineInput placeholder="Confirm Password" type="password" />}
                />
              </LabelWrapper>
            </Grid>
            <Button
              action="submit"
              isLoading={loading}
              isDisabled={
                loading ||
                !values.password ||
                !values.passwordConf ||
                getError('password') ||
                getError('passwordConf')
              }
              type="large"
              className="continue-btn"
            >
              RESET PASSWORD
            </Button>
          </Form>
        </WidthController>
      </div>
    </StyledSignInView>
  )
}

export default ResetPasswordView
